import React from "react";
import { VertTypography } from "@vertem-core/vertice-ds";
import { UserOutlined, ShoppingOutlined, TrophyOutlined, EnvironmentOutlined, CalendarOutlined } from "@ant-design/icons";
import 'Assets/styles/default/components/PopBallon/CustomCard.less';

const WinnerCard = ({ productName, name, city, state, date }) => {
    return (
        <div className="card-wrapper card-wrapper-winners card-direction">
            <div className="trophy-div">
                <TrophyOutlined className='trophy-icon' />
            </div>
            <div>
                <div className="card-content">
                    <VertTypography.Paragraph>
                        <CalendarOutlined className="small-icons" /> {date}
                    </VertTypography.Paragraph>
                </div>
                <div className="card-content">
                    <VertTypography.Paragraph>
                        <UserOutlined className="small-icons" /> {name}
                    </VertTypography.Paragraph>
                </div>
                <div>
                    <div content="card-product">
                        <VertTypography.Paragraph>
                            <ShoppingOutlined className="small-icons" /> {productName}
                        </VertTypography.Paragraph>
                    </div>
                    <div>
                        <VertTypography.Paragraph>
                            <EnvironmentOutlined className="small-icons" /> {city}, {state}
                        </VertTypography.Paragraph>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default WinnerCard;
